// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ib-0";